app.config(function ($translateProvider) {
    $translateProvider.translations('zh-hk', {
        CLEAR_ALL: '清除過濾',
        CLEAR: '清除',
    });
});
